<canvas class="crop-area-overlay">
</canvas>
